import React from 'react'
import classNames from 'classnames'

interface Props {
  index: number
  title: string
  description?: string
  disabled?: boolean
  error?: boolean
  children: React.ReactNode
}

const QuestControlCard = ({
  index,
  title,
  description = '',
  disabled = false,
  error = false,
  children
}: Props) => {
  return (
    <div className={classNames(['quest-control-card', { error, disabled }])}>
      <div className={'quest-control-card__head'}>
        <h2 className={'quest-control-card__title'}>
          <span className={'quest-control-card__title-index'}>
            {index + 1}.
          </span>
          <span className={'quest-control-card__title-text'}>{title}</span>
        </h2>

        {description && (
          <p className={'quest-control-card__description'}>{description}</p>
        )}
      </div>

      <div className={'quest-control-card__content'}>{children}</div>
    </div>
  )
}

export { QuestControlCard }
